import { ExamsResponse, ExamsParams, getExams } from './get-exams';
import * as Models from '../../../models';

export interface AllegedExamsResponse extends ExamsResponse {}

type AllegedExamsParams = {
  oppositionId: Models.OppositionId;
  page?: number;
  pageSize?: number;
  isIncludedInNormalSubscription?: boolean;
};

export const getAlleged = (params: AllegedExamsParams): Promise<AllegedExamsResponse> => {
  const options: ExamsParams = {
    ...params,
    type: Models.ExamType.alleged,
  };

  return getExams(options);
};
